import * as React from 'react';
import { Transition } from 'react-transition-group';

const duration = 680;

const defaultStyle = {
  transition: `opacity ${duration}ms cubic-bezier(0.19, 1, 0.22, 1)`,
  opacity: 0,
  transitionDelay: `420ms`,
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

interface TabPanelTransitionProps {
  predicate: boolean;
}

export const TabPanelTransition: React.FC<TabPanelTransitionProps> = ({
  children,
  predicate,
}) => (
  <Transition in={predicate} timeout={duration}>
    {(state) => (
      <div
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      >
        {children}
      </div>
    )}
  </Transition>
);
